import data from '@emoji-mart/data';
import {EmojiMartData} from '../type/emoji-mart-data';

export const getNativeEmojiById = (id: string, skin: number = 0): string => {
   const castData: EmojiMartData = data as EmojiMartData;
   return castData.emojis[id]?.skins[skin]?.native;
};
export const findEmojiByCode = (emojiCodeWithColons: string): string => getNativeEmojiById(emojiCodeWithColons.replace(/:/g, ''));
